<div class="closeDialogCard" *ngIf="data.closed === false; else reopenTicket">
    <div mat-dialog-title>
        <div class="row">
            <h4 class="col-8 text-uppercase text-left login-header closeTicketHeader">Close Ticket</h4>
            <span class="col-4 text-right">
                <button mat-icon-button class="close-icon" [mat-dialog-close]="false">
                    <i class="fas fa-times"></i>
                </button>
            </span>
        </div>
    </div>
    <div mat-dialog-content>
        <p>This ticket will be closed immediately with no further follow up, if you <b>DO NOT</b> wish to close this
            ticket click Cancel.</p>

        </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button color="primary"
                class="requestBtn" [mat-dialog-close]
                (click)="ticketAction()" cdkfocusinitial>Confirm</button>
        <button mat-raised-button [mat-dialog-close]="true" class="cancelBtn">Cancel</button>
    </div>
</div>

<ng-template class="closeDialogCard" #reopenTicket>
    <div mat-dialog-title>
        <div class="row">
            <h4 class="col-8 text-uppercase text-left login-header closeTicketHeader">Open Ticket</h4>
            <span class="col-4 text-right">
            <button mat-icon-button class="close-icon" [mat-dialog-close]="false">
                <i class="fas fa-times"></i>
            </button>
        </span>
        </div>
    </div>
    <div mat-dialog-content>
        <p>Please confirm if you would like to reopen this ticket.</p>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button color="primary"
                class="requestBtn" [mat-dialog-close]
                (click)="ticketAction()">Confirm</button>
        <button mat-raised-button [mat-dialog-close]="false" class="cancelBtn" cdkfocusinitial>Cancel</button>
    </div>
</ng-template>
